var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("ContinuousReport.Title")))]),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("ContinuousReport.Instructions.TechnicalInstructions")
          )
        }
      }),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "1. " +
            _vm._s(_vm.$t("ContinuousReport.TargetGroupsAndOperation.Title"))
        )
      ]),
      _vm._v(" "),
      _c("target-groups-and-operation-instructions"),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "2. " + _vm._s(_vm.$t("ContinuousReport.MetersAndMonitoring.Title"))
        )
      ]),
      _vm._v(" "),
      _c("meters-and-monitoring-instructions"),
      _vm._v(" "),
      _c("h2", [
        _vm._v("3. " + _vm._s(_vm.$t("ContinuousReport.Collaboration.Title")))
      ]),
      _vm._v(" "),
      _c("collaboration-instructions")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }